import React from 'react';
import moment from 'moment';

const monthNumbers = Array.from({ length: 12 }, (x, i) => i);
const months = monthNumbers.map((element) => {
    let month = moment().month(element).format('MMMM');
    return month;
});

export const CustomDatepickerHeader = (props) => {
    const { date, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled } = props;

    async function handleNavClick(navFunction) {
        await navFunction();
        HandleSelectedWeekDatepicker();
    }

    return (
        <div>
            <button
                onClick={() => handleNavClick(decreaseMonth)}
                disabled={prevMonthButtonDisabled}
                className='react-datepicker__navigation react-datepicker__navigation--previous'
                type='button'
                aria-label='Previous Month'>
                Previous Month
            </button>

            <div className='react-datepicker__current-month'>
                {months[moment(date).month()]}
                {moment(date).year()}
            </div>

            <button
                onClick={() => handleNavClick(increaseMonth)}
                disabled={nextMonthButtonDisabled}
                className='react-datepicker__navigation react-datepicker__navigation--next'
                type='button'
                aria-label='Next Month'>
                Next Month
            </button>
        </div>
    );
};

export const HandleSelectedWeekDatepicker = () => {
    /*let datepickerWeeks = document.getElementsByClassName('react-datepicker__week');
    datepickerWeeks.forEach((element) => {
        let index = element.innerHTML.search('react-datepicker__day--selected');
        if (index !== -1) {
            element.className += ' selected-week';
        } else {
            element.className = 'react-datepicker__week';
        }
        return null;
    });
    */
};
